import { render, staticRenderFns } from "./productivity.vue?vue&type=template&id=6f1fe71a&scoped=true&"
import script from "./productivity.vue?vue&type=script&lang=js&"
export * from "./productivity.vue?vue&type=script&lang=js&"
import style0 from "./productivity.vue?vue&type=style&index=0&id=6f1fe71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1fe71a",
  null
  
)

export default component.exports